// Mock data for Aloha Tequila & Arts Festival

export const eventInfo = {
  name: "ALOHA TEQUILA & ARTS FESTIVAL",
  tagline: "Honolulu's Premier Outdoor Festival Featuring Agave Spirits, Street Food, Music, Art & Flea Market",
  date: "Saturday, June 20th, 2026",
  time: "5:00PM – 9:00PM",
  location: "International Market Place",
  address: "2330 Kalakaua Ave, Waikiki, HI 96815",
  ticketUrl: "https://alohacancer.ticketspice.com/aloha-tequila-arts-festival",
  ticketStatus: "ON SALE",
  edition: "1st Annual"
};

export const ticketInclusions = [
  {
    id: 1,
    title: "World's Best Agave Spirits",
    description: "Enjoy some of the world's best agave spirits paired with your favorite local chefs & restaurants."
  },
  {
    id: 2,
    title: "Premium Tasting Sections",
    description: "VIP Section, Additive Free Alliance, Big Name Brands, Agave Spirits (Mezcal, Sotol, Bacanora), and more."
  },
  {
    id: 3,
    title: "Live Entertainment",
    description: "Live music throughout the venue from some of Oahu's top acts."
  },
  {
    id: 4,
    title: "Culinary Experiences",
    description: "Taco stations from some of your favorite restaurants."
  },
  {
    id: 5,
    title: "Art & Mercado",
    description: "Featuring an array of face painters, shopping, artisans, makers, and thinkers for all ages."
  },
  {
    id: 6,
    title: "21+ to Drink",
    description: "Must be 21+ with valid ID to receive a wristband for alcoholic beverages."
  }
];

export const eventHighlights = [
  "VIP Section with exclusive tastings",
  "Additive Free Alliance Section",
  "Big Name Brands Section",
  "Agave Spirits Section (Mezcal, Sotol, Bacanora)",
  "Mixto Tequilas & Cocktails Section",
  "RTD Tequilas Section",
  "Live Art",
  "Flea Market & Mercado"
];

export const festivalSections = [
  { name: "VIP Section", description: "Exclusive premium tastings" },
  { name: "Additive Free Alliance", description: "Pure, authentic agave spirits" },
  { name: "Big Name Brands", description: "Top rated tequilas in the world" },
  { name: "Agave Spirits", description: "Mezcal, Sotol, Bacanora" },
  { name: "Mixto Tequilas Cocktails", description: "Crafted cocktail experiences" },
  { name: "RTD Tequilas", description: "Ready-to-drink selections" },
  { name: "Live Art & Flea", description: "Local artisans and creators" }
];

export const featuredBrands = [
  // House & local
  "Kapena (Blanco, Reposado, Añejo, Li Hing)",
  "Komoa (Rosa, Añejo, Extra Añejo, Cristalino)",
  // Premium & ultra-premium tequila
  "Don Fulano (Blanco, Fuerte, Reposado, Añejo)",
  "G4 (Blanco, Madera, Blanco High Proof, Reposado, Añejo)",
  "Cuervo Tradicional Blanco",
  "1800 Coconut",
  "Maestro Dobel Diamante Cristalino",
  "Dobel 50 Extra Añejo",
  "Cuervo Reserva de la Familia Platino",
  "Cuervo Reserva de la Familia Extra Añejo",
  "Gran Coramino Reposado",
  "Gran Centenario (Reposado, Añejo)",
  "Volcán (Blanco, Reposado)",
  "El Jimador (Silver, Reposado)",
  "Herradura (Silver, Reposado, Añejo, Ultra Añejo, Legend Añejo)",
  "Angelisco",
  "512",
  "Partida (Original, Roble Fino)",
  "Paladar",
  "Casa Azul",
  "La Gritona",
  "Terralta",
  "Santaleza",
  "Milagro (Core + Barrel Select)",
  "Mandala",
  "Casa Obsidiana",
  "3 Tres (Blanco, Reposado, Añejo, Extra Añejo)",
  "Real del Valle (Blanco, Reposado)",
  "Tequila Ocho",
  "Espolón",
  "Código",
  "El Tesoro",
  "Fortaleza",
  "Corralejo",
  "Cascahuín",
  // Mezcal, Sotol & Bacanora
  "Xicaru Mezcal (Silver, Reposado, Tobalá)",
  "400 Conejos Mezcal",
  "Agave de Cortes Mezcal",
  "El Jolgorio Mezcal",
  "Sotol Por Siempre"
];

export const distributors = [
  "RNDC",
  "SGWS", 
  "Johnson Brothers",
  "Island Beverage"
];

export const images = {
  hero: "https://images.unsplash.com/photo-1645629176800-89b116a7e928?w=1920&q=80",
  logo: "/brand/festival-logo.jpg",
  acpLogo: "/brand/acp-logo.jpg",
  festivalAtmosphere: "https://images.unsplash.com/photo-1768325628097-f47dde70d529?w=800&q=80",
  tequilaBottles: "https://images.unsplash.com/photo-1717116068433-c0896dbd563c?w=800&q=80",
  oceanPier: "https://images.unsplash.com/photo-1677096325567-c6c804dd51a9?w=800&q=80",
  cocktailSetup: "https://images.unsplash.com/photo-1693195083953-c9cdc5fc67ed?w=800&q=80",
  classicCocktail: "https://images.unsplash.com/photo-1541975902628-b157a9411603?w=800&q=80",
  hawaiianSunset: "https://images.pexels.com/photos/5007649/pexels-photo-5007649.jpeg?w=1200&q=80",
  margarita: "https://images.pexels.com/photos/4667084/pexels-photo-4667084.jpeg?w=800&q=80",
  ageVerification: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&q=80",
  tacos: "https://images.unsplash.com/photo-1552332386-f8dd00dc2f85?w=800&q=80",
  mariachi: "https://images.unsplash.com/photo-1769230367366-13ed92feb145?w=800&q=80",
  merchFestivalCrowd: "https://images.unsplash.com/photo-1558355336-905c78a2fae6?w=800&q=80",
  merchAccessories: "https://images.unsplash.com/photo-1764600276946-6e6442174e41?w=800&q=80",
  merchSunglasses: "https://images.unsplash.com/photo-1582142366243-0b6a4aca0d99?w=800&q=80",
  qrInstagram: "https://customer-assets.emergentagent.com/job_7f1a4d17-fffa-4320-92a3-d88e25d69509/artifacts/gs3ynqu4_barcode_www.instagram.com_alohatequilafest.png",
  qrTickets: "https://customer-assets.emergentagent.com/job_7f1a4d17-fffa-4320-92a3-d88e25d69509/artifacts/7zefz4rd_barcode_https___alohacancer.ticketspice.com_aloha-tequila-arts-festival.png"
};

export const alohaCancerProject = {
  name: "Aloha Cancer Project",
  tagline: "Redefining life beyond the disease through fellowship and aloha",
  founded: "2014",
  founders: ["Daniel Gray", "Christa Wittmier (SuperCW)"],
  currentLeaders: ["Flash Hansen"],
  status: "501(c)(3) nonprofit organization",
  location: "Honolulu, Hawaii",
  mission: "To provide an online information hub and financial support for those battling cancer, while holding quarterly fellowship events like healthy cooking demos, yoga and now our first ever festival - Aloha Tequila and Arts Festival.",
  history: "Following the passing of co-founder Daniel Gray in October 2016, the project took a hiatus before being revived in 2017 by Christa Wittmier and Flash Hansen to continue its mission.",
  proceeds: "Proceeds from Aloha Tequila and Arts Fest will go to Aloha Cancer Project 2.0"
};

export const socialLinks = {
  instagram: "https://www.instagram.com/alohatequilafest",
  website: "https://www.alohatequilafest.com",
  email: "everything@8eight8.net"
};
